const DEFAULT_RANGE = [0, 10] as const

interface AssessmentData {
  competencyName: string
  competencyRange: number[] | null
  optionValue?: number
}

export function normalizeData(assessmentData: AssessmentData[]) {
  const { min, max } = getMinMax(assessmentData)

  const data = assessmentData.map((assessment) => {
    const [minValue, maxValue] = assessment.competencyRange ?? DEFAULT_RANGE
    const value = assessment.optionValue ?? minValue

    const normalizedValue = (value - minValue) / (maxValue - minValue)
    const calculatedValue = min + normalizedValue * (max - min)

    const rating =
      calculatedValue % 1 === 0 ? calculatedValue : parseFloat(calculatedValue.toFixed(2))

    return {
      name: assessment.competencyName,
      rating,
      max,
    }
  })

  return {
    min,
    max,
    data,
  }
}

function getMinMax(assessmentData: AssessmentData[]) {
  return assessmentData.reduce(
    (acc, assessment) => {
      const [minRange, maxRange] = assessment.competencyRange ?? DEFAULT_RANGE

      return {
        min: Math.min(acc.min, minRange),
        max: Math.max(acc.max, maxRange),
      }
    },
    { min: Infinity, max: -Infinity }
  )
}
